import { AfterViewInit, Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { CountUp } from 'countup.js';
import { forkJoin } from 'rxjs';
import { FEATURES } from 'src/app/data/feature/feature.data';
import { PARTNERS } from 'src/app/data/partner/partner.data';
import { TESTIMONIALS } from 'src/app/data/testimonial/testimonial.data';
import { Feature } from 'src/app/model/feature/feature.model';
import { Testimonial } from 'src/app/model/testimonial/testimonial.model';
import Swiper from 'swiper';
import { environment } from '../../../../environments/environment';
import { environmentCommon } from '../../../../environments/environment-common';
import { BRAND } from '../../../data/brand/brand.data';
import { URLS } from '../../../data/navigation/navigation.data';
import { LIBRARIES, PLUGINS, PRODUCT_LINES } from '../../../data/product/product.data';
import { Partner } from '../../../model/partner/partner.model';
import { LoadingService } from '../../../service/loading/loading.service';
import SwiperCore, { Autoplay, Navigation, Pagination, Parallax } from 'swiper';
import { SLIDE_IMAGES } from 'src/app/data/gallery/gallery.data';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { NAVIGATIONS } from '../../../data/navigation/navigation.data';


Swiper.use([Navigation, Pagination, Parallax, Autoplay]);


export interface SwiperData {
  title: string;
  description: string;
  img: string;
  background?: string;
  url?: string;
  buttonText?: string;
}

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements AfterViewInit {
  npmDownloadCounter = { count: 0, id: 'npmDownloadCounterElement' };
  totalStarsCounter = { count: 0, id: 'totalStarsCounterElement' };
  openSourceRatioCounter = { count: 0, id: 'openSourceRatioCounterElement' };
  npmCounterLoading = true;
  swiper: Swiper;

  BRAND = BRAND;
  URLS = URLS;
  PRODUCT_LINES = PRODUCT_LINES;
  LIBRARIES = LIBRARIES;
  PLUGINS = PLUGINS;

  slides = SLIDE_IMAGES;

  PARTNERS: Partner[] = PARTNERS;

  TESTIMONIALS: Testimonial[] = TESTIMONIALS.slice(0, TESTIMONIALS.length < 3 ? TESTIMONIALS.length : 3);
  FEATURES: Feature[] = FEATURES;

  KILO = 1000;
  MILLION = this.KILO * this.KILO;

  environment = environment;
  environmentCommon = environmentCommon;

  testimonialsTitle = [
    { text: $localize`:@@homePage.testimonialsTitle.1:Customer testimonials`, level: 2 },
    // { text: $localize`:@@homePage.testimonialsTitle.2:What our customers are saying...` }
  ];

  customersTitle = [
    { text: $localize`:@@homePage.customersTitle.1:SR Group is a pioneer in the sales and service of specialised industrial products.`, level: 2 },
    { text: $localize`:@@homePage.customersTitle.2:Placeholder` }
  ];

  whyUsTitle = [
    { text: $localize`:@@homePage.whyUsTitle.1:Why SR Group?`, level: 2 },
    {
      text: $localize`:@@homePage.whyUsTitle.2:We are driven by a vision of a brighter future and are dedicated to surpassing
customer expectations through the pursuit of efficiency and excellence. Our goal is to provide
our customers with the most advanced products and services at the most cost-effective price,
thereby enabling them to confront future challenges as genuine partners in progress.` }
  ];

  exploreTitle = [
    { text: $localize`:@@homePage.exploreTitle.1:Explore our products`, level: 2 },
    // { text: $localize`:@@homePage.exploreTitle.2:Explore our open source and premium products to get started today.` }
  ];

  andMoreTitle = [
    { text: `And more..`, level: 2 },
    { text: `Open Source libraries and plugins..` }
  ];

  partnershipBadgesTitle = [
    { text: `Business Partners`, level: 2 },
    { text: `Create and run your online business with us and our partners` }
  ];

  constructor(
    private formBuilder: FormBuilder,
    public router: Router,
    private loadingService: LoadingService,
    private titleService: Title,
    private metaService: Meta
  ) {
  }

  ngOnInit() {
    this.setTitleAndMeta();
  }

  ngAfterViewInit() {
    // this.initCountUps();

    this.swiper = new Swiper('.hero-swiper', {
      speed: 600,
      parallax: true,
      loop: true, // Optional: allows continuous looping
      autoplay: {
        delay: 2000, // 3 seconds
        disableOnInteraction: false, // keeps autoplay active after user interaction
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  countUpFormatter(n: number) {
    if (n < this.KILO) {
      return n + '';
    } else {
      if (n < this.MILLION) {
        return Math.round((n / this.KILO) * 10) / 10 + 'k';
      } else {
        return Math.round((n / this.MILLION) * 10) / 10 + 'M';
      }
    }
  }

  getPresentationCardFooter(isOpenSource: boolean): string {
    return isOpenSource ? $localize`:@@productTypeTag.openSource:opensource` : $localize`:@@productTypeTag.premium:premium`;
  }

  private initCountUps() {
    const options = {
      useGrouping: false,
      duration: undefined,
      formattingFn: undefined,
      decimalPlaces: 0
    };

    this.totalStarsCounter.count = 0;

    let totalProducts = 0;

    this.openSourceRatioCounter.count = 0;

    const promises: Promise<any>[] = [];
    for (const system of [PRODUCT_LINES, LIBRARIES, PLUGINS]) {

      for (const productLine of system) {

        totalProducts += productLine.products.length;

        for (const product of productLine.products) {
          if (product.url !== URLS.maintenance && product.openSource) {
            // promises.push( this.githubService.getGithubStars( product.key ) );
          }

          if (product.openSource) {
            this.openSourceRatioCounter.count++;
          }
        }
      }
    }

    forkJoin(promises).subscribe(results => {
      results.forEach(result => {
        this.totalStarsCounter.count += result.count;
      });
      this.startCounter(options, this.totalStarsCounter);
    });

    this.openSourceRatioCounter.count = (this.openSourceRatioCounter.count / totalProducts) * 100;

    this.startCounter(options, this.openSourceRatioCounter);
  }

  private startCounter(options: { duration: number; useGrouping: boolean; formattingFn, decimalPlaces: number }, counter) {
    options.formattingFn = (n: number) => {
      return this.countUpFormatter(n);
    };

    if (counter.count < this.KILO) {
      options.duration = 2;
    } else if (counter.count < this.MILLION) {
      options.duration = 3;
    } else {
      options.duration = 4;
    }

    const eventCountUp = new CountUp(counter.id, counter.count, options);
    if (!eventCountUp.error) {
      eventCountUp.start();
    } else {
      console.error(eventCountUp.error);
    }
  }

  setTitleAndMeta() {
    this.titleService.setTitle(NAVIGATIONS.root.title);
    this.metaService.updateTag({ name: 'description', content: NAVIGATIONS.root.meta });
  }
}
